import { axiosInstance } from './common';

export const listUsers = (search, page = 0, size = 20) => {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  params.append('page', page);
  params.append('size', size);
  return axiosInstance.get(`/admin/users?${params.toString()}`).then((r) => r.data);
};

export const createUser = (username, email, password, role, subscriptionTier) =>
  axiosInstance.post('/admin/users', { username, email, password, role, subscriptionTier }).then((r) => r.data);

export const updateUserStatus = (userId, enabled) =>
  axiosInstance.put(`/admin/users/${userId}/status`, { enabled }).then((r) => r.data);

export const resetUserPassword = (userId, newPassword) =>
  axiosInstance.put(`/admin/users/${userId}/reset-password`, { newPassword }).then((r) => r.data);

export const deleteUser = (userId) =>
  axiosInstance.delete(`/admin/users/${userId}`).then((r) => r.data);

export const changeUserRole = (userId, role) =>
  axiosInstance.put(`/admin/users/${userId}/role`, { role }).then((r) => r.data);
